(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('OutdoorStaticController', OutdoorStaticController);

    OutdoorStaticController.$inject = ['$state', '$log', 'CartFactory', 'AreaService', '$translate', '$rootScope', 'AreaCalculationService', '$filter', '$localStorage'];

    function OutdoorStaticController($state, $log, CartFactory, AreaService, $translate, $rootScope, AreaCalculationService, $filter, $localStorage) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];

        vm.outdoorAreaStatic = {
            cartPositionPrice: 0,
            cartPositionParent: null,
            cartPositionLabel: null,
            cartPositionId: null
        };
        vm.toggleOwnContainer = true;

        vm.bookArea = bookArea;
        vm.calc = calculate;
        vm.pageLoaded = pageLoaded;
        vm.toggle = toggle;
        vm.goBack = back;


        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Outdoor_area_static').then(successPrices, error);
            AreaService.loadLabels('Outdoor_area_static').then(successLabels, error);
            AreaService.loadCartLabels('Outdoor_area_static').then(successCartLabels, error)
        }

        function successPrices(response) {
            $log.debug("OutdoorStaticController | Fetching prices ", response.data);
            vm.prices = response.data
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("OutdoorStaticController | Fetching text labels ", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('OutdoorStaticController | Fetching cart label', response.data);
            vm.outdoorAreaStatic.cartPositionLabel = response.data;
        }

        function error(response) {
            $log.debug('OutdoorStaticController | ERROR:', response);
        }

        function calculate() {
            vm.outdoorAreaStatic.squaremeters = parseFloat(vm.outdoorAreaStatic.length * vm.outdoorAreaStatic.width);

            if (vm.outdoorAreaStatic.squaremeters > 0) {
                calculateAreaPrice();
            }
        }

        function toggle() {
            vm.toggleOwnContainer = !vm.toggleOwnContainer;
        }

        function bookArea() {
            calculateAreaPrice();

            var item = {
                type: 'Area',
                areaType: 'Outdoor_area_static',
                cartPositionPrice: vm.outdoorAreaStatic.cartPositionPrice,
                cartPositionParent: null,
                cartPositionLabel: vm.outdoorAreaStatic.cartPositionLabel,
                cartPositionId: null,
                length: vm.outdoorAreaStatic.length,
                width: vm.outdoorAreaStatic.width,
                squaremeters: squareMetersToDouble(vm.outdoorAreaStatic.squaremeters),
                fields: {
                    suggestions: vm.outdoorAreaStatic.suggestions,
                    weExhibit: vm.outdoorAreaStatic.weexhibit,
                    requestedContainerOffer: vm.outdoorAreaStatic.requestedContainerOffer,
                    requestedTentOffer: vm.outdoorAreaStatic.requestedTentOffer,
                    tentOrContainerWidth: vm.outdoorAreaStatic.containerWidth,
                    tentOrContainerLength: vm.outdoorAreaStatic.containerLength
                },
                id: null
            };
            $localStorage.showSuccessAlert = true;

            $log.debug('OutdoorStaticController | adding item to cart', item);

            CartFactory.addItem(item);
            $state.go('area');
        }

        function back() {
            $state.go('area');
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function squareMetersToDouble(squaremeters) {
            return parseFloat(squaremeters);
        }

        function pageLoaded() {
            // TODO
            return true;
        }

        function calculateAreaPrice() {
            vm.outdoorAreaStatic.cartPositionPrice = AreaCalculationService.calculateAreaPrice(vm.prices, vm.outdoorAreaStatic.squaremeters);
        }

        return vm;
    }
})();
